export * from '@macs-frontend/core/base/base-component';
